import { Form, Formik } from "formik";
import { Button, CheckBox, Input, Upload } from "../../../custom";
import styles from "../styles.module.scss";
import React, { FC, useEffect, useState } from "react";
import { ReactComponent as Image } from "../../../assets/image.svg";
import { object } from "yup";
import { validator } from "../../../utils/validator";

interface ComponentProps {
  editIndex: number | null;
  workHistory: WorkHistory[];
  isLoading: boolean;
  buttonText: string;
  certificateUrl?: string;
  onSubmit: (values: WorkHistory) => void;
}

const WorkHistoryForm: FC<ComponentProps> = ({
  buttonText,
  certificateUrl,
  editIndex,
  workHistory,
  isLoading,
  onSubmit,
}) => {
  const [imageUrl, setImageUrl] = useState("");
  const [isCurrentJob, setIsCurrentJob] = useState(false);

  useEffect(() => {
    setImageUrl(certificateUrl ?? "");
  }, [certificateUrl]);

  const handleRemoveImageUrl = () => {
    setImageUrl("");
  };

  const validationSchema = object().shape({
    company: validator.company,
    position: validator.position,
    startDate: validator.startDate,
    ...(!isCurrentJob && { endDate: validator.endDate }),
    upload: validator.upload,
  });

  useEffect(() => {
    if (editIndex !== null) {
      setIsCurrentJob(workHistory[editIndex]?.currentJob ?? false);
    }
  }, [editIndex, workHistory])

  return (
    <Formik<WorkHistory>
      initialValues={
        editIndex !== null
          ? workHistory[editIndex]
          : {
              company: "",
              position: "",
              currentJob: false,
              startDate: "",
              endDate: "",
              upload: null,
            }
      }
      validationSchema={validationSchema}
      onSubmit={(values) => {
        onSubmit(values);
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <Form>
            <div>
              <Input
                name="company"
                label="Company"
                placeholder="Enter company"
              />

              <div className={styles.checkbox}>
                <CheckBox
                  name="currentJob"
                  label="Current Job"
                  isChecked={values.currentJob}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const { checked } = e.target;
                    setFieldValue("currentJob", checked);
                    setIsCurrentJob(checked);
                  }}
                />
              </div>
            </div>

            <br />

            <Input
              name="position"
              label="Position"
              placeholder="Enter position"
            />

            <br />

            <section className={styles.grid}>
              <Input
                type="date"
                name="startDate"
                label="Start Date"
                placeholder="Enter date"
              />
              
              <Input
                type="date"
                name="endDate"
                label="End Date"
                placeholder="Enter date"
                disabled={isCurrentJob}
              />
            </section>

            <br />

            {certificateUrl ? (
              <div className="small-gap">
                <Image />
                <span>{imageUrl}</span>
                <Button
                  onClick={handleRemoveImageUrl}
                  text="x"
                  className={styles.cancel}
                />
              </div>
            ) : (
              <Upload
                name="upload"
                label="CV OR Resume"
                description={<small style={{ color: "#888", display: "block", marginBottom: "4px" }}>Accepted formats: PDF or JPEG only</small>}
                allowedFormats={["PDF", "JPEG"]}
                fileName={values.upload ? values.upload.name : ""}
                onChange={(e) => {
                  const file = e.target.files;
                  if (file) {
                    setFieldValue("upload", file[0]);
                  }
                }}
              />
            )}

            <br />

            <div className={styles.buttonWrapper}>
              <Button
                type="submit"
                text={buttonText}
                isLoading={isLoading}
                className={styles.buttonSize}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default WorkHistoryForm;
